export default __webpack_public_path__ + "static/media/gameMusic.3e00a089.mp3";